export enum AppStatus {
  Running = "Running ",
  Maintenance = "Maintenance",
}
export const appStatus: AppStatus =
  (process.env.REACT_APP_STATUS as AppStatus) ?? AppStatus.Running;
